import docLinks from '@@/i18n/locales/documents.json'

export function useDocLinks() {
  return docLinks
}
